import React, { useState, useEffect, useRef } from "react";

function CreateStrategy() {
  // 🔥 Single dropdown state
  const [openDropdown, setOpenDropdown] = useState(null);

  const dropdownRef = useRef(null);

  // Selected values
  const [indexSelected, setIndexSelected] = useState("NIFTY");
  const [entryTimeSelected, setEntryTimeSelected] = useState("09:15 AM");
  const [exitTimeSelected, setExitTimeSelected] = useState("14:55 PM");
  const [expirySelected, setExpirySelected] = useState("Select Market Expiry");
  const [selectedDays, setSelectedDays] = useState([]);
  const [orderSelected, setOrderSelected] = useState("BUY");
  const [distanceSelected, setDistanceSelected] = useState("BUY ON DIPS");

  // 🔥 Outside click close
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const timeOptions = [];
  for (let h = 9; h <= 15; h++) {
    for (let m = 0; m < 60; m++) {
      if (h === 9 && m < 15) continue;
      if (h === 15 && m > 30) break;

      const suffix = h < 12 ? "AM" : "PM";
      const hour = h > 12 ? h - 12 : h;
      const label = `${hour}:${m.toString().padStart(2, "0")} ${suffix}`;
      timeOptions.push(label);
    }
  }
  return (
    <main className="create_strategy pt_150 pb_100">
      <section className="strategy_form_section">
        <div className="container">
          <div class="section_title ">
            <h2>Create Custom Strategy</h2>
          </div>

          <form className="strategy_form">
            {/* Step 1: Entry Settings */}
            <div className="form_step">
              <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-12 col-12 form_group">
                  <label>Strategy Name</label>
                  <input type="text" placeholder="Enter strategy name" />
                </div>

                {/* Index Dropdown */}
                <div className="col-lg-4 col-md-6 col-sm-12 col-12 form_group">
                  <label>Index</label>
                  <div className="custom_dropdown">
                    <div
                      className="dropdown_box"
                      onClick={() =>
                        setOpenDropdown(
                          openDropdown === "index" ? null : "index",
                        )
                      }
                    >
                      {indexSelected}
                      <span className="arrow">
                        {openDropdown === "index" ? "▲" : "▼"}
                      </span>
                    </div>

                    {openDropdown === "index" && (
                      <ul className="dropdown_menu">
                        {["NIFTY", "BANK NIFTY", "SENSEX"].map((opt) => (
                          <li
                            key={opt}
                            className={indexSelected === opt ? "active" : ""}
                            onClick={() => {
                              setIndexSelected(opt);
                              setOpenDropdown(null);
                            }}
                          >
                            {opt}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>

                <div className="col-lg-4 col-md-6 col-sm-12 col-12 form_group">
                  <label>Capital (₹)</label>
                  <input type="number" placeholder="Amount in INR" />
                </div>

                {/* Entry Time Dropdown */}
                <div className="col-lg-4 col-md-6 col-sm-12 col-12 form_group">
                  <label>Entry Time</label>
                  <div className="custom_dropdown">
                    <div
                      className="dropdown_box"
                      onClick={() =>
                        setOpenDropdown(
                          openDropdown === "entryTime" ? null : "entryTime",
                        )
                      }
                    >
                      {entryTimeSelected}
                      <span className="arrow">
                        {openDropdown === "entryTime" ? "▲" : "▼"}
                      </span>
                    </div>

                    {openDropdown === "entryTime" && (
                      <ul className="dropdown_menu">
                        {timeOptions.map((opt) => (
                          <li
                            key={opt}
                            className={
                              entryTimeSelected === opt ? "active" : ""
                            }
                            onClick={() => {
                              setEntryTimeSelected(opt);
                              setOpenDropdown(null);
                            }}
                          >
                            {opt}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
                {/* Enter on Days - Custom Multi Select Dropdown */}
                <div className="col-lg-4 col-md-6 col-sm-12 col-12 form_group">
                  <label>Enter on Days</label>
                  <div className="custom_dropdown">
                    <div
                      className="dropdown_box"
                      onClick={() =>
                        setOpenDropdown(openDropdown === "days" ? null : "days")
                      }
                    >
                      {selectedDays.length
                        ? selectedDays.join(", ")
                        : "Select Days"}
                      <span className="arrow">
                        {openDropdown === "days" ? "▲" : "▼"}
                      </span>
                    </div>

                    {openDropdown === "days" && (
                      <ul className="dropdown_menu">
                        {["Mon", "Tue", "Wed", "Thu", "Fri"].map((day) => (
                          <li
                            key={day}
                            className={
                              selectedDays.includes(day) ? "active" : ""
                            }
                            onClick={() => {
                              if (selectedDays.includes(day)) {
                                setSelectedDays(
                                  selectedDays.filter((d) => d !== day),
                                );
                              } else {
                                setSelectedDays([...selectedDays, day]);
                              }
                            }}
                          >
                            {day}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
                {/* Strategy Type - Radio */}
                <div className="col-lg-4 col-md-6 col-sm-12 col-12 form_group">
                  <label>Strategy Type</label>
                  <div className="custom_select">
                    <label className="radio_btn">
                      <input type="radio" name="stype" /> Intraday
                    </label>
                    <label className="radio_btn">
                      <input type="radio" name="stype" /> Positional
                    </label>
                  </div>
                </div>

                {/* Order Execute Dropdown */}
                <div className="col-lg-4 col-md-6 col-sm-12 col-12 form_group">
                  <label>Order Execute</label>
                  <div className="custom_dropdown">
                    <div
                      className="dropdown_box"
                      onClick={() =>
                        setOpenDropdown(
                          openDropdown === "order" ? null : "order",
                        )
                      }
                    >
                      {orderSelected}
                      <span className="arrow">
                        {openDropdown === "order" ? "▲" : "▼"}
                      </span>
                    </div>

                    {openDropdown === "order" && (
                      <ul className="dropdown_menu">
                        {["BUY", "SELL"].map((opt) => (
                          <li
                            key={opt}
                            className={orderSelected === opt ? "active" : ""}
                            onClick={() => {
                              setOrderSelected(opt);
                              setOpenDropdown(null);
                            }}
                          >
                            {opt}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>

                {/* Distance Buy/Sell Dropdown */}
                <div className="col-lg-4 col-md-6 col-sm-12 col-12 form_group">
                  <label>Distance Buy/Sell</label>
                  <div className="custom_dropdown">
                    <div
                      className="dropdown_box"
                      onClick={() =>
                        setOpenDropdown(
                          openDropdown === "distance" ? null : "distance",
                        )
                      }
                    >
                      {distanceSelected}
                      <span className="arrow">
                        {openDropdown === "distance" ? "▲" : "▼"}
                      </span>
                    </div>

                    {openDropdown === "distance" && (
                      <ul className="dropdown_menu">
                        {["BUY ON DIPS", "SELL ON TOP"].map((opt) => (
                          <li
                            key={opt}
                            className={distanceSelected === opt ? "active" : ""}
                            onClick={() => {
                              setDistanceSelected(opt);
                              setOpenDropdown(null);
                            }}
                          >
                            {opt}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>

                {/* Execution Type - Checkbox */}
                <div className="col-lg-4 col-md-6 col-sm-12 col-12 form_group">
                  <label>Execution Type</label>
                  <div className="custom_select mt-2">
                    <label className="checkbox_btn">
                      <input type="checkbox" /> Live Trading
                    </label>
                    <label className="checkbox_btn">
                      <input type="checkbox" /> Forward Test
                    </label>
                  </div>
                </div>
              </div>
            </div>

            {/* Step 2: Strategy Legs */}
            <div className="form_step">
              <div className="d-flex justify-content-between align-items-center">
                <h3>Step 2: Strategy Legs</h3>
                {/* <button
                  type="button"
                  onClick={addLeg}
                  className="btn_style_one"
                >
                  + Add Leg
                </button> */}
              </div>

              {/* {legs.map((leg) => (
                <div key={leg} className="leg_box">
                  <h5>Leg #{leg}</h5>
                  <div className="row">
                    <div className="col-md-4 form_group">
                      <label>Instrument</label>
                      <div className="custom_dropdown">
                        <div
                          className="dropdown_box"
                          onClick={() => setExpiryOpen(!expiryOpen)}
                        >
                          {expirySelected}
                          <span className="arrow">
                            {expiryOpen ? "▲" : "▼"}
                          </span>
                        </div>
                        {expiryOpen && (
                          <ul className="dropdown_menu">
                            {[
                              "Current Week",
                              "Next Week",
                              "Current Month",
                              "Next Month",
                            ].map((opt) => (
                              <li
                                key={opt}
                                className={
                                  expirySelected === opt ? "active" : ""
                                }
                                onClick={() => {
                                  setExpirySelected(opt);
                                  setExpiryOpen(false);
                                }}
                              >
                                {opt}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))} */}
              <div className="leg_box">
                <h5>Leg #{}</h5>
                <div className="row">
                  <div className="col-md-4 form_group">
                    <label>Lot Size</label>
                    <input type="number" placeholder="Enter Lot Size" />
                  </div>{" "}
                  <div className="col-md-4 form_group">
                    <label>Total Trades In One Channel</label>
                    <input type="number" placeholder="Enter Total Trades" />
                  </div>
                  <div className="col-md-4 form_group">
                    <label>Market Expiry</label>
                    <div className="custom_dropdown">
                      <div
                        className="dropdown_box"
                        onClick={() =>
                          setOpenDropdown(
                            openDropdown === "expiry" ? null : "expiry",
                          )
                        }
                      >
                        {expirySelected}
                        <span className="arrow">
                          {openDropdown === "expiry" ? "▲" : "▼"}
                        </span>
                      </div>

                      {openDropdown === "expiry" && (
                        <ul className="dropdown_menu">
                          {[
                            "INTRADAY",
                            "WEEKLY",
                            "MONTHLY",
                            "TWO MONTH",
                            "QUARTERLY",
                          ].map((opt) => (
                            <li
                              key={opt}
                              className={expirySelected === opt ? "active" : ""}
                              onClick={() => {
                                setExpirySelected(opt);
                                setOpenDropdown(null);
                              }}
                            >
                              {opt}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                  <div className="col-md-4 form_group">
                    <label>Magic Number</label>
                    <input type="number" placeholder="Enter Magic Number" />
                  </div>
                </div>
              </div>
            </div>

            {/* Step 3: Exit Settings */}
            <div className="form_step">
              <h3>Exit Settings</h3>
              <div className="col-md-4 form_group">
                <label>Exit Time</label>
                <div className="custom_dropdown">
                  <div
                    className="dropdown_box"
                    onClick={() =>
                      setOpenDropdown(
                        openDropdown === "exitTime" ? null : "exitTime",
                      )
                    }
                  >
                    {exitTimeSelected}
                    <span className="arrow">
                      {openDropdown === "exitTime" ? "▲" : "▼"}
                    </span>
                  </div>

                  {openDropdown === "exitTime" && (
                    <ul className="dropdown_menu">
                      {timeOptions.map((opt) => (
                        <li
                          key={opt}
                          className={exitTimeSelected === opt ? "active" : ""}
                          onClick={() => {
                            setExitTimeSelected(opt);
                            setOpenDropdown(null);
                          }}
                        >
                          {opt}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="form_actions">
              <button type="button" className="btn_style_two">
                Cancel
              </button>
              <button type="submit" className="btn_style_one">
                Create Strategy
              </button>
            </div>
          </form>
        </div>
      </section>
    </main>
  );
}

export default CreateStrategy;
